import { makeStyles } from 'tss-react/mui';

const useStylesCard: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  cardContainer: {
    width: 'auto',
    overflow: 'visible !important',
    padding: 20,
  },
  cardDark: {
    backgroundColor: `${theme.palette.primary.main} !important`,
  },
  cardScrollable: {
    overflowY: 'scroll !important',
  },
  cardSelectable: {
    cursor: 'pointer',
  },
  cardActive: {
    backgroundColor: `${theme.palette.secondary.light} !important`,
  },
  cardFullWidth: {
    width: '100%',
  },
  cardFullHeight: {
    height: '100%',
  },
  cardNoPadding: {
    padding: 0,
  },
  cardSmallPadding: {
    padding: '10px 20px',
  },
  cardNoBackground: {
    background: 'none !important',
  },
  cardFlat: {
    boxShadow: 'none !important',
  },
}));

export default useStylesCard;
